// extracted by mini-css-extract-plugin
export default {"cont":"index_cont__YdN3O","big_title":"index_big_title__0XQJR","card":"index_card__FYHv6","item":"index_item__Mhv43"};